import { Component } from "./presentation/Component";
import { redux } from "./redux";

export const moduleDefinition = {
  component: Component,
  redux,
};
